/**
 * Pre-register — expandable details toggle
 * Toggles the "Dowiedz się więcej" section with smooth animation
 */

(function () {
    'use strict';

    var toggle = document.getElementById('prereg-toggle');
    var details = document.getElementById('prereg-details');

    if (!toggle || !details) return;

    toggle.addEventListener('click', function (e) {
        e.preventDefault();

        var isOpen = details.classList.toggle('is-open');
        toggle.textContent = isOpen ? '[Zwiń]' : '[Dowiedz się więcej]';
    });
})();
